<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="8">
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <div class="d-lg-none align-self-center">
                    <b-row align-content="center">
                      <b-col></b-col>
                      <b-col cols="2">
                        <img
                          src="./../../assets/logo.jpg"
                          height="50px"
                          width="auto"
                        />
                      </b-col>
                      <b-col cols="6" class="text-left" align-self="center">
                        <span
                          class="navbar-brand-full pl-2"
                          style="
                            font-size: 16px;
                            font-weight: 500;
                            color: black;
                          "
                        >
                          VL Digimart
                        </span>
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                  </div>
                  <form @submit.prevent="appLogin">
                    <h1>Login</h1>
                    <p class="text-muted">Sign In to your account</p>
                    <p v-if="msg" style="color: red">{{ msg }}</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Username"
                        autocomplete="Username"
                        v-model="login.Username"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Password"
                        autocomplete="current-password"
                        v-model="login.Password"
                        required
                      />
                    </b-input-group>
                    <b-row>
                      <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-sm btn-block"
                          style="
                            color: white;
                            font-weight: 500;
                            background-color: #9200ac;
                          "
                          @click.prevent="appLogin('seller')"
                        >
                          Login
                        </button>
                      </b-col>
                      <!-- <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-info btn-sm btn-block"
                          style="color: white; font-weight: 500"
                          @click.prevent="appLogin('admin')"
                        >
                          Admin Login
                        </button>
                      </b-col> -->
                      <!-- <b-col cols="6" class="text-right">
                        <b-button variant="link" class="px-0">Forgot password?</b-button>
                      </b-col>-->
                    </b-row>
                  </form>
                </b-card-body>
              </b-card>
              <b-card
                no-body
                class="text-white py-5 d-md-down-none"
                style="width: 44%"
              >
                <b-card-body class="text-center">
                  <div>
                    <b-row>
                      <b-col>
                        <img
                          src="./../../assets/logo.jpg"
                          height="50px"
                          width="auto"
                        />
                      </b-col>
                    </b-row>
                  </div>
                  <div style="color: #9200ac">
                    <h2>VL Digimart Admin Panel</h2>
                    <p>
                      The admin panel to monitor the day to day reports and
                      other services with exciting features.
                    </p>
                    <!-- <b-button
                      variant="primary"
                      class="active mt-3"
                      to="/Register"
                    >
                      Register Now!
                    </b-button> -->
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="col-md-12">
      <!--footer-->
      <a href="#"></a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      <b style="float: right">
        <a href="http://jissjohnson.info" target="_blank">
          <span class="mr-1">Powered by Shopio</span>
        </a>
      </b>
    </div>
  </div>
</template>

<script>
// Admin
// Username : 9544497526
// Password : jissjohnson
// Shop
// Username : jissjohnson
// Password : jissjohnson
import axios from "axios";
import store from "../../store";
export default {
  name: "login",
  data() {
    return {
      login: {
        Username: null,
        MobileNo: null,
        Password: null,
      },
      msg: null,
      appLoading: false,
      ServerError: false,
    };
  },
  methods: {
    appLogin(item) {
      var seller = "/shop/login";
      var admin = "/user/login";
      this.appLoading = true;
      this.msg = null;
      this.login.MobileNo = this.login.Username;
      axios({
        method: "POST",
        url: seller,
        data: this.login,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("loginUser", response.data.data.raw);
            localStorage.setItem("token", response.data.data.token);
            if (response.data.data.shop)
              localStorage.setItem("shopid", response.data.data.shop.id);

            this.$notify({
              group: "appNotification",
              title: "Login Success",
              text: "",
              type: "success",
              position: "bottom right",
            });
            this.$router.push("/Dashboard");
          } else {
            this.msg = response.data.msg;
            this.$notify({
              group: "appNotification",
              title: response.data.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
